import { Trans } from '@lingui/macro'
import { authRoles, ALLOCATION_COMMITTEE_GROUP } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { RESOURCE_INVENTORY_PATHS } from './ResourcesConstants'

const MyEntries = EgretLoadable({
  loader: async () => await import('./ResourceInventoryMyEntries')
})

const MyShelf = EgretLoadable({
  loader: async () => await import('./MyShelfPage')
})

const ResourceInventory = EgretLoadable({
  loader: async () => await import('./ResourceInventory')
})

const CreateNewResource = EgretLoadable({
  loader: async () => await import('./ResourceInventoryMyEntries/CreateNewResource')
})

export const resourceInventoryRoutes: RouteConfig[] = [
  {
    path: RESOURCE_INVENTORY_PATHS.resourceInventory,
    component: ResourceInventory,
    functionPermissions: [
      ({ user }) =>
        user.groupMemberships?.includes(ALLOCATION_COMMITTEE_GROUP) ||
        user.roles?.includes('GRANTEE')
    ],
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_RESOURCES</Trans>
  },
  {
    path: RESOURCE_INVENTORY_PATHS.resourceInventoryMyShelf,
    component: MyShelf,
    functionPermissions: [
      ({ user }) =>
        user.groupMemberships?.includes(ALLOCATION_COMMITTEE_GROUP) ||
        user.roles?.includes('GRANTEE')
    ],
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_MY_SHELF</Trans>,
    showCollapseBtn: true
  },
  {
    path: RESOURCE_INVENTORY_PATHS.resourceInventoryMyEntries,
    component: MyEntries,
    functionPermissions: [
      ({ user }) =>
        user.groupMemberships?.includes(ALLOCATION_COMMITTEE_GROUP) ||
        user.roles?.includes('GRANTEE')
    ],
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_MY_RESOURCE_ENTRIES</Trans>,
    showCollapseBtn: true
  },
  {
    path: RESOURCE_INVENTORY_PATHS.resourceInventorySubmitResource + '/:id?',
    component: CreateNewResource,
    functionPermissions: [
      ({ user }) =>
        user.groupMemberships?.includes(ALLOCATION_COMMITTEE_GROUP) ||
        user.roles?.includes('GRANTEE')
    ],
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_RESOURCE_INVENTORY_SUBMIT_RESOURCE_LABEL</Trans>,
    errorRedirectPath: RESOURCE_INVENTORY_PATHS.resourceInventoryMyEntries
  }
]
